<template>
  <template v-if="currentOrg.isRecordingStudioPricingEnabled || !isEURegion()">
    <VideoLibraryTableDialog
      :initialSelectedVideoAssets="initialSelectedVideoAssets"
      :maxSelections="maxSelections"
      @close="$emit('close')"
      @select-videos="assets => $emit('select-videos', assets)"
    />
  </template>
  <template v-else>
    <AssetLibraryDialog
      title="Select Videos"
      :initialSelectedAssets="initialSelectedVideoAssets"
      :getAssetsFn="getVideoAssets"
      :primaryActionTitle="isSaving ? 'Saving...' : 'Save'"
      :isPrimaryActionDisabled="isSaving"
      :maxSelections="maxSelections"
      @close="$emit('close')"
      @select="assets => $emit('select-videos', assets)"
    >
      <template #upload-button="{ success, init, failure, close }">
        <UploadVideo @success="success" @init="init" @failure="failure" @close="close">
          <StudioButton trackingId="upload-video-button">
            <template #icon>
              <TablerPlus />
            </template>
            Upload Video
          </StudioButton>
        </UploadVideo>
      </template>
      <template #assets-list-item="{ asset, isSelected, handleSelectAsset, handleDeleteSuccess, handleRenameSuccess }">
        <VideoLibraryListItem
          :videoAsset="asset"
          :isSelected="isSelected"
          allowSelection
          :visibleActions="{
            openPreview: true,
            download: true,
            rename: true,
            delete: true
          }"
          @select-video="handleSelectAsset"
          @delete-success="handleDeleteSuccess"
          @rename-success="handleRenameSuccess"
        />
      </template>
    </AssetLibraryDialog>
  </template>
</template>

<script>
import { defineComponent } from 'vue';
import { mapState } from 'vuex';

import UploadVideo from './UploadVideo.vue';
import VideoLibraryListItem from './VideoLibraryListItem.vue';
import { getVideoAssets } from './videoLibraryService';
import VideoLibraryTableDialog from './VideoLibraryTableDialog.vue';

import AssetLibraryDialog from '@/studio/studioLibrary/AssetLibraryDialog.vue';
import TablerPlus from '@/studioComponents/Icons/tabler/TablerPlus.vue';
import StudioButton from '@/studioComponents/StudioButton.vue';
import { isEURegion } from '@/utils';

/**
 * @deprecated This component is deprecated and will be removed in a future version.
 * Use VideoLibraryTableDialog instead.
 */
export default defineComponent({
  name: 'VideoLibraryDialog',
  components: {
    AssetLibraryDialog,
    StudioButton,
    UploadVideo,
    VideoLibraryListItem,
    VideoLibraryTableDialog,
    TablerPlus
  },
  props: {
    initialSelectedVideoAssets: {
      type: Array,
      default: () => []
    },
    maxSelections: {
      type: Number,
      default: Infinity
    },
    isSaving: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapState('org', { currentOrg: 'currentOrg' })
  },
  methods: {
    getVideoAssets,
    isEURegion
  }
});
</script>
